import { YearSelector } from "../../../../components";
import { Box, Text, useToast } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import {
  useGetScopeTwoConversionFactors
} from "../../../../hooks/query/conversion-factors";
import { mapScopeTwoFactorsData } from "../helpers";
import { showErrorToast } from "../../../../utils";
import { DataTable } from "../../../../components/DataTable";

function ScopeTwoFactorsTab({ selectedYear, setSelectedYear }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors.headers"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const [scopeTwoFactorsData, setScopeTwoFactorsData] = useState([]);

  const {
    isFetching
  } = useGetScopeTwoConversionFactors({
    year: selectedYear
  }, {
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setScopeTwoFactorsData(mapScopeTwoFactorsData(data));
      } else {
        setScopeTwoFactorsData([]);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  const columns = useMemo(() => {
    return [
      {
        header: t("country"),
        accessorKey: "country",
        size: 200
      },
      {
        header: t("electricityType"),
        accessorKey: "electricityType",
        size: 150
      },
      {
        header: t("conversionFactor"),
        accessorKey: "conversionFactor",
        size: 200,
        enableColumnFilter: false
      }
    ];
  }, [t]);

  return (
    <Box>
      <YearSelector selectedYear={selectedYear} handleYearSelection={(value) => setSelectedYear(value)} />
      {!scopeTwoFactorsData || scopeTwoFactorsData.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <DataTable
          data={scopeTwoFactorsData}
          columns={columns}
          isLoading={isFetching}
          enableFilters={true}
        />
      }
    </Box>
  );
}

export default ScopeTwoFactorsTab;